module.exports = __webpack_public_path__ + "img/0Q3A5798_L_WoodMatted.85d18a58.jpg";